import { clsx } from 'clsx';
import { Clock, RefreshCw } from 'lucide-react';
import { useState, useEffect } from 'react';
import { SiteSelector } from './SiteSelector.jsx';

// Lehe ülaserva pealkirjariba — minimaalne hele teema, kompaktne info paremal.

export function Header({ title, connected, lastUpdate, onRefresh, showSiteSelector = false }) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatLastUpdate = (timestamp) => {
    if (!timestamp) return '—';
    const diff = Date.now() - timestamp;
    if (diff < 5000) return 'just nüüd';
    if (diff < 60000) return `${Math.floor(diff / 1000)}s tagasi`;
    return new Date(timestamp).toLocaleTimeString('et-EE');
  };

  return (
    <header className="h-12 bg-white border-b border-[var(--border)] px-5 flex items-center justify-between">
      <h1 className="text-sm font-semibold text-zinc-900 tracking-tight">{title}</h1>

      <div className="flex items-center gap-5 text-[11px] text-zinc-500">
        {/* Site selector — kuva ainult kui showSiteSelector prop on true (multi-site juhtimiseks).
            Töölaud ja muud ülevaate-lehed ei vaja saidi valikut. */}
        {showSiteSelector && <SiteSelector />}

        {/* Värskendatud */}
        {lastUpdate !== undefined && (
          <div className="flex items-center gap-1.5">
            <RefreshCw
              className={clsx('w-3 h-3', onRefresh && 'cursor-pointer hover:text-zinc-900')}
              strokeWidth={1.75}
              onClick={onRefresh}
            />
            <span className="tabular-nums">{formatLastUpdate(lastUpdate)}</span>
          </div>
        )}

        {/* Ühenduse staatus — väike täpp + tekst */}
        <div className="flex items-center gap-1.5">
          <span
            className={clsx(
              'w-1.5 h-1.5 rounded-full',
              connected ? 'bg-green-600' : 'bg-zinc-300'
            )}
          />
          <span className={clsx(connected ? 'text-zinc-700' : 'text-zinc-400')}>
            {connected ? 'ühendatud' : 'ühendamata'}
          </span>
        </div>

        {/* Kell */}
        <div className="flex items-center gap-1.5">
          <Clock className="w-3 h-3" strokeWidth={1.75} />
          <span className="tabular-nums">{time.toLocaleTimeString('et-EE')}</span>
        </div>
      </div>
    </header>
  );
}

export default Header;
